import { NavLink, Outlet } from 'react-router-dom';
import {
  LayoutDashboard,
  Mic2,
  Disc3,
  Music,
  Tags,
  Users,
  CreditCard,
  DollarSign,
  Bell,
  FileText,
  LogOut,
} from 'lucide-react';
import { useAuth } from '../auth';

const navItems = [
  { to: '/', label: 'Dashboard', Icon: LayoutDashboard },
  { to: '/artists', label: 'Artists', Icon: Mic2 },
  { to: '/albums', label: 'Albums', Icon: Disc3 },
  { to: '/tracks', label: 'Tracks', Icon: Music },
  { to: '/genres', label: 'Genres', Icon: Tags },
  { to: '/users', label: 'Users', Icon: Users },
  { to: '/subscriptions', label: 'Subscriptions', Icon: CreditCard },
  { to: '/affiliate-payouts', label: 'Affiliate Payouts', Icon: DollarSign },
  { to: '/notifications', label: 'Notifications', Icon: Bell },
  { to: '/audit-log', label: 'Audit Log', Icon: FileText },
];

export function Layout() {
  const { user, logout } = useAuth();
  return (
    <div className="flex min-h-screen">
      <aside className="w-64 glass m-3 mr-0 p-5 flex flex-col rounded-r-none">
        <div className="mb-8 flex items-center gap-3">
          <img src="/logo.png" alt="Ndule" className="w-10 h-10 rounded-lg" />
          <div>
            <div className="text-accent text-xl font-bold tracking-tight">Ndule</div>
            <div className="text-text2 text-[11px] uppercase tracking-widest">Admin</div>
          </div>
        </div>
        <nav className="flex-1 flex flex-col gap-1">
          {navItems.map(({ to, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `px-3 py-2.5 rounded-lg text-sm transition flex items-center gap-3 ${
                  isActive
                    ? 'bg-action-gradient text-white font-semibold shadow-glow'
                    : 'text-text2 hover:bg-[rgba(48,86,156,0.4)] hover:text-white'
                }`
              }
            >
              <Icon size={18} strokeWidth={2} className="opacity-90 shrink-0" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-[rgba(120,170,240,0.18)] pt-4 mt-4">
          <div className="text-xs text-textmuted truncate">{user?.email}</div>
          <button
            onClick={logout}
            className="mt-2 text-xs text-text2 hover:text-danger transition flex items-center gap-1.5"
          >
            <LogOut size={12} strokeWidth={2} />
            Log out
          </button>
        </div>
      </aside>
      <main className="flex-1 p-8 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
